import { render, staticRenderFns } from "./SectionError.vue?vue&type=template&id=e40c3256"
import script from "./SectionError.vue?vue&type=script&lang=ts"
export * from "./SectionError.vue?vue&type=script&lang=ts"
import style0 from "./SectionError.vue?vue&type=style&index=0&id=e40c3256&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports